import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class ManualAreasExpertiseExperience extends _BaseUserProfile {
  component = 'TextArea';
  props = {
    title: null,
    description: 'Tell Operators in your own words about any special skills, training,' +
    'experience, safety record, etc.  Go ahead, market yourself!',
    label: 'Enter Special Skills, Training, Experience, Safety Record, etc.',
    errorMessage: 'Please Select Areas of Expertise and Experience',
  };
}
